import {ACTIONS} from '../../constants/sessions';
import {encode} from '../../services/common';
import {CookieStorageApi} from '../../api/storage';
import {COOKIES_SESSION_STORE_KEY} from '../../constants/cookies';

export function ActionSessionStart(startValues, expires, remember = false) {
  const encodedString = encode(startValues);
  CookieStorageApi.set(COOKIES_SESSION_STORE_KEY, encodedString, expires);
  return {
    type: ACTIONS.START,
    data: startValues,
    remember,
  };
}

export function ActionSessionClear() {
  return {
    type: ACTIONS.CLEAR,
  };
}

export function ActionSessionUpdate(value, expires, remember) {
  const encodedString = encode(value);
  CookieStorageApi.set(COOKIES_SESSION_STORE_KEY, encodedString, expires);
  return {
    type: ACTIONS.UPDATE,
    data: value,
    remember,
  };
}
